import { isReadOnly } from '@/lib/permissions'
import { formatDateTime } from '@/lib/utils'
import { useFetchSCR, usePatientByHashQuery } from '@/services/patients'
import { Box, Button, Chip, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'

const FetchScr = (props: React.ComponentProps<typeof Button>) => {
  const { hash } = useParams<{ hash: string }>()
  if (!hash) {
    throw new Error('Patient hash is required for fetching SCR')
  }
  const readOnly = isReadOnly()
  const { data: patient } = usePatientByHashQuery(hash)
  const { mutate: fetchSCR, isPending } = useFetchSCR(hash)
  const postCode = patient.primaryAddress?.postalCode
  const environment = import.meta.env.VITE_VERCEL_ENV === 'production' ? 'production' : 'staging'
  const lastUpdated = patient.summaryCareRecordLastUpdated

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: props.fullWidth ? '100%' : 'auto' }}>
      {lastUpdated && (
        <Typography
          component={Chip}
          variant='caption'
          color='text.secondary'
          label={`Last fetched: ${formatDateTime(lastUpdated)}`}
          sx={{ whiteSpace: 'nowrap' }}
        />
      )}
      <Button
        onClick={() => {
          if (readOnly) return
          fetchSCR({
            first_name: patient.firstName,
            last_name: patient.lastName,
            date_of_birth: patient.dob,
            postcode: postCode!,
            id: patient.hash,
            service: 'wp',
            environment
          })
        }}
        variant='secondary'
        disabled={isPending || !postCode || readOnly}
        loading={isPending}
        size='large'
        {...props}
        fullWidth={false}
      >
        {postCode ? 'Fetch SCR' : 'Postcode required to fetch SCR'}
      </Button>
    </Box>
  )
}

export default FetchScr
